import React from 'react'
import styled from 'styled-components'
import { DarkTheme } from '../components/Themes'




const Logo = styled.h1`
display: inline-block;
color: ${props => props.color === 'dark' ? DarkTheme.text : DarkTheme.body};
font-family: 'Pacifico',cursive;

position: fixed;
left: 2rem;
top: 2rem;
z-index:3;
 @media (max-width: 768px) {
    font-size: 1.2rem; /* Further decrease font size for mobile view */
    left: 0.8rem; /* Adjust position for mobile view if needed */
    top: 2.5rem; /* Adjust position for mobile view if needed */
  }
`


const LogoComponent = (props) => {
    return (
        <Logo color={props.theme}>
          MP
        </Logo>
    )
}

export default LogoComponent
